export default "__VITE_ASSET__BeFBFH7___"